import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import React from 'react'

const DeleteRaceModal = ({ visible, setVisible, onClickYes, subscribeModal = false }) => {
    return (
        <>
            <CModal
                alignment="center"
                visible={visible.open}
                onClose={() => setVisible({open: false, raceId: null})}
                size='sm'
                aria-labelledby="VerticallyCenteredExample"
                keyboard={true}
            >
                <CModalHeader>
                      <CModalTitle id="VerticallyCenteredExample">Удалить гонку?</CModalTitle>
                </CModalHeader>
                <CModalFooter style={{ display: 'flex', justifyContent: 'space-evenly', borderTop: 'unset' }} >
                    <CButton onClick={onClickYes} style={{ color: '#fff', padding : '3px 50px' }} color="primary">
                        Да
                    </CButton>
                    <CButton style={{ color: '#fff', padding : '3px 50px' }} color="secondary" onClick={() => setVisible({open: false, raceID: null})}>
                        Нет
                    </CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}

export default DeleteRaceModal